import React, { Component } from 'react'
import { Document } from './types'
import { request } from '../helpers/apiHelper'
import { uploadDocumentMutation } from '../features/common/queries'
import { Configuration } from '../core/types'

export interface Props {
  configuration: Configuration
}

export class SignatureUploader extends Component<Props> {
  static displayName = 'SignatureUploader'

  state: { isUploading: boolean; error: Error | null } = {
    isUploading: false,
    error: null
  }

  getBase64 = (file): Promise<string | ArrayBuffer | null> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file[0] ? file[0] : file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }

  uploadSignature = (event) => {
    const { configuration } = this.props
    const signature = event.target.files?.[0]

    let document: Document = {
      type: 'SIGNATURE',
      description: "signature",
      imageableId: configuration.id,
      imageableType: "CONFIGURATION"
    }

    this.setState({
      isUploading: true,
      error: null
    })

    this.getBase64(signature).then((res) => {
      document.image = res

      return request(uploadDocumentMutation, { image: document })
      .then((res) => {
        if (res.data.errors) {
          throw new Error(res.data.errors[0].message)
        } else {
          this.setState({
            isUploading: false,
          })
        }
      })
      .catch((error) => {
        this.setState({
          isUploading: false,
          error: error
        })
      })
    })
  }

  render() {
    return (
      <div>
        <input
          type="file"
          accept="image/*"
          name="signature"
          onChange={this.uploadSignature}
          disabled={this.state.isUploading}
        />
        {this.state.isUploading && <span>Uploading…</span>}
        {this.state.error && <span style={{ color: 'red' }}>{this.state.error?.message}</span>}
      </div>
    )
  }
}

export default SignatureUploader